import React from 'react';
import ProductCard from '../../components/Boutique/ProductCard';
import '../../styles/Boutique/LaBoutique.css';
import '../../styles/Boutique/Category.css';
import '../../styles/Boutique/Cart.css';
import '../../styles/Boutique/BoutiqueLayout.css';
import '../../styles/Boutique/Products.css';

const ProductList = ({ products, selectedCategories, priceSort, addToCart }) => {
  let filteredProducts = [...products];

  if (selectedCategories.length > 0) {
    filteredProducts = products.filter(p => selectedCategories.includes(p.category));
  }

  if (priceSort !== 'none') {
    filteredProducts.sort((a, b) => priceSort === 'asc' ? a.price - b.price : b.price - a.price);
  }

  return (
    <div className="products-grid">
      {filteredProducts.map(product => (
        <ProductCard key={product.name} product={product} addToCart={addToCart} />
      ))}
    </div>
  );
};

export default ProductList;
